export interface UniversityUpdateRequest {
  country: string;
  names: { [language: string]: string };
  description: string;
  testTemplatesForApplications?: string[];
  testTemplatesForAutoSend?: string[];
}
